import script from "./ModalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalHeader.vue?vue&type=script&setup=true&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=cfd7a542&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd7a542"]])

export default __exports__